import { render, staticRenderFns } from "./PersonWithPesel.vue?vue&type=template&id=5caac0ad&"
import script from "./PersonWithPesel.vue?vue&type=script&lang=js&"
export * from "./PersonWithPesel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports